import {
    BuildDistroBuild,
    FetchBuildDistributionBucketBuildResponse,
    FetchBuildDistributionBucketBuildsWorkItemsTimelineResponse,
    FetchBuildDistributionSharedWithMeBuildsResponse,
    ShareBuildDistributionBuildWithTestersResponse,
    UpdateBuildDistributionBuildTesterNotesResponse,
    ArchiveBuildDistributionBuildResponse,
    FetchBuildDistributionBucketDownloadMetricsResponse,
} from './../types';
import {
    ArchiveBuildDistributionBucketResponse,
    BuildDistroBucketBase,
    CreateBuildDistributionBucketResponse,
    FetchBuildDistributionBucketResponse,
    FetchBuildDistributionBucketsWithRecentBuildsResponse,
} from '../types';
import {
    AddBuildDistroBucketMembersRequest,
    AppEntityRequest,
    ArchiveBuildDistributionBucketRequest,
    BucketEntityRequest,
    CreateBuildDistributionBucketRequest,
    RemoveBuildDistroBucketMemberRequest,
    ToggleBuildDistroBucketNotificationsRequest,
    UpdateBuildDistroBucketMemberPermissionsRequest,
    UpdateBuildDistroBucketNotificationSettingsRequest,
    UpdateBuildDistributionBuildTesterNotesRequest,
    UpdateBuildDistributionBucketRequest,
    ShareBuildDistributionBuildWithTestersRequest,
    UpdateBuildDistroBucketAutomationSettingsRequest,
    ArchiveBuildDistributionBuildRequest,
} from './entities';
import { BuildDistributionUpdatable } from './updatable';

export const FETCH_BUILD_DISTRIBUTION_BUILD_WORK_ITEMS_TIMELINE_SUCCESS =
    'FETCH_BUILD_DISTRIBUTION_BUILD_WORK_ITEMS_TIMELINE_SUCCESS';
export const FETCH_BUILD_DISTRIBUTION_BUCKETS_WITH_RECENT_BUILDS_SUCCESS =
    'FETCH_BUILD_DISTRIBUTION_BUCKETS_WITH_RECENT_BUILDS_SUCCESS';
export const FETCH_BUILD_DISTRIBUTION_BUCKET_SUCCESS = 'FETCH_BUILD_DISTRIBUTION_BUCKET_SUCCESS';
export const FETCH_BUILD_DISTRIBUTION_BUCKET_BUILD_SUCCESS = 'FETCH_BUILD_DISTRIBUTION_BUCKET_BUILD_SUCCESS';
export const FETCH_BUILD_DISTRIBUTION_BUCKET_BUILDS_SUCCESS = 'FETCH_BUILD_DISTRIBUTION_BUCKET_BUILDS_SUCCESS';
export const FETCH_BUILD_DISTRIBUTION_SHARED_WITH_ME_BUILDS_SUCCESS =
    'FETCH_BUILD_DISTRIBUTION_SHARED_WITH_ME_BUILDS_SUCCESS';
export const FETCH_BUILD_DISTRIBUTION_BUCKET_DOWNLOAD_METRICS_SUCCESS =
    'FETCH_BUILD_DISTRIBUTION_BUCKET_DOWNLOAD_METRICS_SUCCESS';

export const TRY_ARCHIVE_BUILD_DISTRIBUTION_BUCKET = 'TRY_ARCHIVE_BUILD_DISTRIBUTION_BUCKET';
export const ARCHIVE_BUILD_DISTRIBUTION_BUCKET_SUCCESS = 'ARCHIVE_BUILD_DISTRIBUTION_BUCKET_SUCCESS';

export const UPDATE_BUILD_DISTRIBUTION_BUILD_TESTERS = 'UPDATE_BUILD_DISTRIBUTION_BUILD_TESTERS';
export const UPDATE_BUILD_DISTRIBUTION_BUILD_TESTERS_SUCCESS = 'UPDATE_BUILD_DISTRIBUTION_BUILD_TESTERS_SUCCESS';

export const TRY_NEW_BUILD_DISTRIBUTION_BUCKET = 'TRY_NEW_BUILD_DISTRIBUTION_BUCKET';
export const NEW_BUILD_DISTRIBUTION_BUCKET_SUCCESS = 'NEW_BUILD_DISTRIBUTION_BUCKET_SUCCESS';
export const UPDATE_BUILD_DISTRIBUTION_BUCKET_SUCCESS = 'UPDATE_BUILD_DISTRIBUTION_BUCKET_SUCCESS';
export const UPDATE_BUILD_DISTRIBUTION_BUCKETS_SUCCESS = 'UPDATE_BUILD_DISTRIBUTION_BUCKETS_SUCCESS';
export const UPLOAD_BUILD_DISTRIBUTION_BUILD_SUCCESS = 'UPLOAD_BUILD_DISTRIBUTION_BUILD_SUCCESS';
export const UPDATE_BUILD_DISTRIBUTION_BUILD_TESTER_NOTES = 'UPDATE_BUILD_DISTRIBUTION_BUILD_TESTER_NOTES';
export const UPDATE_BUILD_DISTRIBUTION_BUILD_TESTER_NOTES_SUCCESS =
    'UPDATE_BUILD_DISTRIBUTION_BUILD_TESTER_NOTES_SUCCESS';
export const ARCHIVE_BUILD_DISTRIBUTION_BUILD = 'ARCHIVE_BUILD_DISTRIBUTION_BUILD';
export const ARCHIVE_BUILD_DISTRIBUTION_BUILD_SUCCESS = 'ARCHIVE_BUILD_DISTRIBUTION_BUILD_SUCCESS';

export const TRIGGER_BUILD_DISTRIBUTION_BUILD = 'TRIGGER_BUILD_DISTRIBUTION_BUILD';

export interface FetchBuildDistributionBucketsWithRecentBuildsResponsePayload extends AppEntityRequest {
    bucketsAndBuilds: FetchBuildDistributionBucketsWithRecentBuildsResponse;
}

export interface FetchBuildDistributionBucketResponsePayload extends AppEntityRequest {
    bucket: FetchBuildDistributionBucketResponse;
}

export interface FetchBuildDistributionBucketBuildResponsePayload extends AppEntityRequest {
    build: FetchBuildDistributionBucketBuildResponse;
}

export interface NewBuildDistributionBucketSuccessResponse extends AppEntityRequest {
    bucket: CreateBuildDistributionBucketResponse;
}

export interface ArchiveBuildDistributionBucketSuccessResponse extends AppEntityRequest {
    bucket: ArchiveBuildDistributionBucketResponse;
}

export interface FetchBuildDistributionBucketBuildsResponsePayload extends AppEntityRequest {
    bucketId: string;
    builds: BuildDistroBuild[];
}

export interface FetchBuildDistributionBucketDownloadMetricsResponsePayload extends AppEntityRequest {
    bucketId: string;
    metrics: FetchBuildDistributionBucketDownloadMetricsResponse;
}

export interface FetchBuildDistributionSharedWithMeBuildsResponsePayload
    extends AppEntityRequest,
        FetchBuildDistributionSharedWithMeBuildsResponse {}

export interface FetchBuildDistributionBuildWorkItemsTimelineResponsePayload
    extends AppEntityRequest,
        FetchBuildDistributionBucketBuildsWorkItemsTimelineResponse {
    buildId: string;
}

export interface UpdateBuildDistributionBuildTesterNotesSuccessResponse extends AppEntityRequest {
    build: UpdateBuildDistributionBuildTesterNotesResponse;
}

export interface ArchiveBuildDistributionBuildSuccessResponse extends AppEntityRequest {
    build: ArchiveBuildDistributionBuildResponse;
}

export interface ShareBuildDistributionBuildWithTestersSuccessResponse extends AppEntityRequest {
    build: ShareBuildDistributionBuildWithTestersResponse;
}

export interface ShareBuildDistributionBuildWithTestersSuccessAction {
    type: typeof UPDATE_BUILD_DISTRIBUTION_BUILD_TESTERS_SUCCESS;
    payload: ShareBuildDistributionBuildWithTestersSuccessResponse;
}

export const shareBuildDistributionBuildWithTestersSuccess: (
    payload: ShareBuildDistributionBuildWithTestersSuccessResponse,
) => ShareBuildDistributionBuildWithTestersSuccessAction = (payload) => {
    return {
        type: UPDATE_BUILD_DISTRIBUTION_BUILD_TESTERS_SUCCESS,
        payload,
    };
};

export interface FetchBuildDistributionBucketsSuccessAction {
    type: typeof FETCH_BUILD_DISTRIBUTION_BUCKETS_WITH_RECENT_BUILDS_SUCCESS;
    payload: FetchBuildDistributionBucketsWithRecentBuildsResponsePayload;
}

export const fetchBuildDistributionBucketsWithRecentBuildsSuccess: (
    payload: FetchBuildDistributionBucketsWithRecentBuildsResponsePayload,
) => FetchBuildDistributionBucketsSuccessAction = (payload) => {
    return {
        type: FETCH_BUILD_DISTRIBUTION_BUCKETS_WITH_RECENT_BUILDS_SUCCESS,
        payload,
    };
};

export interface FetchBuildDistributionBucketSuccessAction {
    type: typeof FETCH_BUILD_DISTRIBUTION_BUCKET_SUCCESS;
    payload: FetchBuildDistributionBucketResponsePayload;
}

export const fetchBuildDistributionBucketSuccess: (
    payload: FetchBuildDistributionBucketResponsePayload,
) => FetchBuildDistributionBucketSuccessAction = (payload) => {
    return {
        type: FETCH_BUILD_DISTRIBUTION_BUCKET_SUCCESS,
        payload,
    };
};

export interface FetchBuildDistributionBucketBuildSuccessAction {
    type: typeof FETCH_BUILD_DISTRIBUTION_BUCKET_BUILD_SUCCESS;
    payload: FetchBuildDistributionBucketBuildResponsePayload;
}

export const fetchBuildDistributionBucketBuildSuccess: (
    payload: FetchBuildDistributionBucketBuildResponsePayload,
) => FetchBuildDistributionBucketBuildSuccessAction = (payload) => {
    return {
        type: FETCH_BUILD_DISTRIBUTION_BUCKET_BUILD_SUCCESS,
        payload,
    };
};

export interface FetchBuildDistributionBucketDownloadMetricsSuccessAction {
    type: typeof FETCH_BUILD_DISTRIBUTION_BUCKET_DOWNLOAD_METRICS_SUCCESS;
    payload: FetchBuildDistributionBucketDownloadMetricsResponsePayload;
}

export const fetchBuildDistributionBucketDownloadMetricsSuccess: (
    payload: FetchBuildDistributionBucketDownloadMetricsResponsePayload,
) => FetchBuildDistributionBucketDownloadMetricsSuccessAction = (payload) => {
    return {
        type: FETCH_BUILD_DISTRIBUTION_BUCKET_DOWNLOAD_METRICS_SUCCESS,
        payload,
    };
};

export interface FetchBuildDistributionBucketBuildsSuccessAction {
    type: typeof FETCH_BUILD_DISTRIBUTION_BUCKET_BUILDS_SUCCESS;
    payload: FetchBuildDistributionBucketBuildsResponsePayload;
}

export const fetchBuildDistributionBucketBuildsSuccess: (
    payload: FetchBuildDistributionBucketBuildsResponsePayload,
) => FetchBuildDistributionBucketBuildsSuccessAction = (payload) => {
    return {
        type: FETCH_BUILD_DISTRIBUTION_BUCKET_BUILDS_SUCCESS,
        payload,
    };
};

export interface FetchBuildDistributionSharedWithMeBuildsSuccessAction {
    type: typeof FETCH_BUILD_DISTRIBUTION_SHARED_WITH_ME_BUILDS_SUCCESS;
    payload: FetchBuildDistributionSharedWithMeBuildsResponsePayload;
}

export const fetchBuildDistributionSharedWithMeBuildsSuccess: (
    payload: FetchBuildDistributionSharedWithMeBuildsResponsePayload,
) => FetchBuildDistributionSharedWithMeBuildsSuccessAction = (payload) => {
    return {
        type: FETCH_BUILD_DISTRIBUTION_SHARED_WITH_ME_BUILDS_SUCCESS,
        payload,
    };
};

export interface FetchBuildDistributionBuildWorkItemsTimelineSuccessAction {
    type: typeof FETCH_BUILD_DISTRIBUTION_BUILD_WORK_ITEMS_TIMELINE_SUCCESS;
    payload: FetchBuildDistributionBuildWorkItemsTimelineResponsePayload;
}

export const fetchBuildDistributionBuildWorkItemsTimelineSuccess: (
    payload: FetchBuildDistributionBuildWorkItemsTimelineResponsePayload,
) => FetchBuildDistributionBuildWorkItemsTimelineSuccessAction = (payload) => {
    return {
        type: FETCH_BUILD_DISTRIBUTION_BUILD_WORK_ITEMS_TIMELINE_SUCCESS,
        payload,
    };
};

export interface ShareBuildDistributionBuildWithTestersAction {
    type: typeof UPDATE_BUILD_DISTRIBUTION_BUILD_TESTERS;
    payload: ShareBuildDistributionBuildWithTestersRequest;
}

export const tryShareBuildDistributionBuildWithTesters: (
    payload: ShareBuildDistributionBuildWithTestersRequest,
) => ShareBuildDistributionBuildWithTestersAction = (payload) => {
    return {
        type: UPDATE_BUILD_DISTRIBUTION_BUILD_TESTERS,
        payload,
    };
};

export interface UpdateBuildDistributionBuildTesterNotesAction {
    type: typeof UPDATE_BUILD_DISTRIBUTION_BUILD_TESTER_NOTES;
    payload: UpdateBuildDistributionBuildTesterNotesRequest;
}

export const tryUpdateBuildDistributionBuildTesterNotes: (
    payload: UpdateBuildDistributionBuildTesterNotesRequest,
) => UpdateBuildDistributionBuildTesterNotesAction = (payload) => {
    return {
        type: UPDATE_BUILD_DISTRIBUTION_BUILD_TESTER_NOTES,
        payload,
    };
};

export interface UpdateBuildDistributionBuildTesterNotesSuccessAction {
    type: typeof UPDATE_BUILD_DISTRIBUTION_BUILD_TESTER_NOTES_SUCCESS;
    payload: UpdateBuildDistributionBuildTesterNotesSuccessResponse;
}

export const updateBuildDistributionBuildTesterNotesSuccess: (
    payload: UpdateBuildDistributionBuildTesterNotesSuccessResponse,
) => UpdateBuildDistributionBuildTesterNotesSuccessAction = (payload) => {
    return {
        type: UPDATE_BUILD_DISTRIBUTION_BUILD_TESTER_NOTES_SUCCESS,
        payload,
    };
};

export interface ArchiveBuildDistributionBuildAction {
    type: typeof ARCHIVE_BUILD_DISTRIBUTION_BUILD;
    payload: ArchiveBuildDistributionBuildRequest;
}

export const tryArchiveBuildDistributionBuild: (
    payload: ArchiveBuildDistributionBuildRequest,
) => ArchiveBuildDistributionBuildAction = (payload) => {
    return {
        type: ARCHIVE_BUILD_DISTRIBUTION_BUILD,
        payload,
    };
};

export interface ArchiveBuildDistributionBuildSuccessAction {
    type: typeof ARCHIVE_BUILD_DISTRIBUTION_BUILD_SUCCESS;
    payload: ArchiveBuildDistributionBuildSuccessResponse;
}

export const archiveBuildDistributionBuildSuccess: (
    payload: ArchiveBuildDistributionBuildSuccessResponse,
) => ArchiveBuildDistributionBuildSuccessAction = (payload) => {
    return {
        type: ARCHIVE_BUILD_DISTRIBUTION_BUILD_SUCCESS,
        payload,
    };
};

export interface TryArchiveBuildDistributionBucketAction {
    type: typeof TRY_ARCHIVE_BUILD_DISTRIBUTION_BUCKET;
    payload: ArchiveBuildDistributionBucketRequest;
}

export const tryArchiveBuildDistributionBucket: (
    payload: ArchiveBuildDistributionBucketRequest,
) => TryArchiveBuildDistributionBucketAction = (payload) => {
    return {
        type: TRY_ARCHIVE_BUILD_DISTRIBUTION_BUCKET,
        payload,
    };
};

export interface TryNewBuildDistributionBucketAction {
    type: typeof TRY_NEW_BUILD_DISTRIBUTION_BUCKET;
    payload: CreateBuildDistributionBucketRequest;
}

export const tryNewBuildDistributionBucket: (
    payload: CreateBuildDistributionBucketRequest,
) => TryNewBuildDistributionBucketAction = (payload) => {
    return {
        type: TRY_NEW_BUILD_DISTRIBUTION_BUCKET,
        payload,
    };
};

export interface TriggerBuildDistributionBuildRequest extends AppEntityRequest {
    bucketId: string;
}

export interface TriggerBuildDistributionBuildAction {
    type: typeof TRIGGER_BUILD_DISTRIBUTION_BUILD;
    payload: TriggerBuildDistributionBuildRequest;
}

export const triggerBuildDistributionBuild: (
    payload: TriggerBuildDistributionBuildRequest,
) => TriggerBuildDistributionBuildAction = (payload) => {
    return {
        type: TRIGGER_BUILD_DISTRIBUTION_BUILD,
        payload,
    };
};

export interface NewBuildDistributionBucketSuccessAction {
    type: typeof NEW_BUILD_DISTRIBUTION_BUCKET_SUCCESS;
    payload: NewBuildDistributionBucketSuccessResponse;
}

export const newBuildDistributionBucketSuccess: (
    payload: NewBuildDistributionBucketSuccessResponse,
) => NewBuildDistributionBucketSuccessAction = (payload) => {
    return {
        type: NEW_BUILD_DISTRIBUTION_BUCKET_SUCCESS,
        payload,
    };
};

export interface ArchiveBuildDistributionBucketSuccessAction {
    type: typeof ARCHIVE_BUILD_DISTRIBUTION_BUCKET_SUCCESS;
    payload: ArchiveBuildDistributionBucketSuccessResponse;
}

export const archiveBuildDistributionBucketSuccess: (
    payload: ArchiveBuildDistributionBucketSuccessResponse,
) => ArchiveBuildDistributionBucketSuccessAction = (payload) => {
    return {
        type: ARCHIVE_BUILD_DISTRIBUTION_BUCKET_SUCCESS,
        payload,
    };
};

export type TryUpdateBuildDistributionBucketRequest<T = BuildDistributionUpdatable> =
    T extends BuildDistributionUpdatable.RemoveBuildDistroBucketMember ? RemoveBuildDistroBucketMemberRequest
    : T extends BuildDistributionUpdatable.AddBuildDistroBucketMembers ? AddBuildDistroBucketMembersRequest
    : T extends BuildDistributionUpdatable.UpdateBuildDistroBucketMemberPermissions ?
        UpdateBuildDistroBucketMemberPermissionsRequest
    : T extends BuildDistributionUpdatable.ToggleBuildDistroBucketNotifications ?
        ToggleBuildDistroBucketNotificationsRequest
    : T extends BuildDistributionUpdatable.UpdateBuildDistroBucketNotificationSettings ?
        UpdateBuildDistroBucketNotificationSettingsRequest
    : T extends BuildDistributionUpdatable.UpdateBuildDistroBucketAutomationSettings ?
        UpdateBuildDistroBucketAutomationSettingsRequest
    : T extends BuildDistributionUpdatable.UpdateBuildDistroBucket ? UpdateBuildDistributionBucketRequest
    : object;

export interface TryUpdateBuildDistributionBucketAction<T = BuildDistributionUpdatable> {
    type: T;
    payload: TryUpdateBuildDistributionBucketRequest<T>;
}

export const tryUpdateBuildDistributionBucket: <T extends BuildDistributionUpdatable>(
    type: T,
    payload: TryUpdateBuildDistributionBucketRequest<T>,
) => TryUpdateBuildDistributionBucketAction<T> = (type, payload) => {
    return {
        type,
        payload,
    };
};

export interface UpdateBuildDistributionBucketSuccessResponse extends BucketEntityRequest {
    bucket: BuildDistroBucketBase;
}

export interface UpdateDistributionBucketSuccessAction {
    type: typeof UPDATE_BUILD_DISTRIBUTION_BUCKET_SUCCESS;
    payload: UpdateBuildDistributionBucketSuccessResponse;
}

export const updateDistributionBucketSuccess: (
    payload: UpdateBuildDistributionBucketSuccessResponse,
) => UpdateDistributionBucketSuccessAction = (payload) => {
    return {
        type: UPDATE_BUILD_DISTRIBUTION_BUCKET_SUCCESS,
        payload,
    };
};

export interface UpdateBuildDistributionBucketsSuccessResponse extends AppEntityRequest {
    buckets: BuildDistroBucketBase[];
}
export interface UpdateDistributionBucketsSuccessAction {
    type: typeof UPDATE_BUILD_DISTRIBUTION_BUCKETS_SUCCESS;
    payload: UpdateBuildDistributionBucketsSuccessResponse;
}

export const updateDistributionBucketsSuccess: (
    payload: UpdateBuildDistributionBucketsSuccessResponse,
) => UpdateDistributionBucketsSuccessAction = (payload) => {
    return {
        type: UPDATE_BUILD_DISTRIBUTION_BUCKETS_SUCCESS,
        payload,
    };
};

export interface UploadBuildDistributionBuildSuccessResponse extends BucketEntityRequest {
    build: BuildDistroBuild;
}

export interface UploadBuildDistributionBuildSuccessAction {
    type: typeof UPLOAD_BUILD_DISTRIBUTION_BUILD_SUCCESS;
    payload: UploadBuildDistributionBuildSuccessResponse;
}

export const uploadBuildDistributionBuildSuccess: (
    payload: UploadBuildDistributionBuildSuccessResponse,
) => UploadBuildDistributionBuildSuccessAction = (payload) => {
    return {
        type: UPLOAD_BUILD_DISTRIBUTION_BUILD_SUCCESS,
        payload,
    };
};
